import React from 'react';

/**
 * AdBanner — long/wide banner slot for third-party or in-house promotions
 * on the Home page.
 *
 * Layout: 5:1 aspect ratio (leaderboard-style) so it looks like a real ad
 * unit. Content is centred so an square source image (like the current
 * SarvaRitam logo) works naturally against its own background color.
 *
 * When you're ready to swap the creative, just change `src` / `href` /
 * `bg` — the container never breaks.
 */
const DEFAULT_AD = {
  src: '/ads/banner1.jpeg',
  alt: 'SarvaRitam — The Essence Of All That Is Right & Natural',
  href: null,       // set a URL to make the banner clickable
  bg: '#000000',    // matches the image background for seamless letterbox
  sponsored: true,  // shows a small "Sponsored" pill top-right
};

export default function AdBanner({ ad = DEFAULT_AD, className = '' }) {
  const inner = (
    <div
      data-testid="home-ad-banner"
      className={`relative w-full rounded-2xl overflow-hidden border border-white/10 ${className}`}
      style={{ background: ad.bg, aspectRatio: '5 / 1' }}
    >
      {ad.sponsored && (
        <span
          className="absolute top-2 right-2 z-10 px-1.5 py-0.5 rounded-full text-[9px] font-semibold uppercase tracking-wider bg-white/10 text-white/70 backdrop-blur"
          data-testid="home-ad-sponsored"
        >
          Sponsored
        </span>
      )}
      {/* image centered, height-first so it scales with the row */}
      <img
        src={ad.src}
        alt={ad.alt}
        loading="lazy"
        className="absolute inset-0 m-auto h-full max-h-[110%] w-auto object-contain"
        draggable={false}
      />
    </div>
  );

  if (ad.href) {
    return (
      <a
        href={ad.href}
        target="_blank"
        rel="noopener sponsored"
        className="block hover:opacity-95 transition"
        data-testid="home-ad-link"
      >
        {inner}
      </a>
    );
  }
  return inner;
}
